<template>
  <div class="page" v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(0, 0, 0, 0.1)">
    <div class="card">
      <div class="mb20">
        <el-button type="primary" @click="start">{{ $t('system.start') }}</el-button>
        <el-button type="primary" :disabled="!loaded" @click="exportReport">{{ $t('system.export') }}</el-button>
      </div>

      <p class="mb10">{{ $t('system.env') }}：{{ userAgent }}</p>
      <el-row class="mb20" :gutter="20">
        <el-col :xs="24" :md="12" :lg="4" :xl="4"
          >IP: <span class="f18">{{ status.ipValue }}</span></el-col
        >
        <el-col :xs="24" :md="12" :lg="4" :xl="4"
          >Ping: <span class="f18">{{ status.pingString }}</span></el-col
        >
        <el-col :xs="24" :md="12" :lg="4" :xl="4"
          >Download: <span class="f18">{{ status.downloadString }}</span></el-col
        >
        <el-col :xs="24" :md="12" :lg="4" :xl="4"
          >Upload: <span class="f18">{{ status.uploadString }}</span></el-col
        >
      </el-row>
    </div>

    <NetworkPaper ref="NetworkPaper" :data="printData"></NetworkPaper>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Worker from '../../plugins/workers/network.worker';
import NetworkPaper from './NetworkPaper';
import auth from '../../common/auth';
import aegis from '../../common/apm';

const worker = new Worker();

export default {
  name: 'Network',
  components: {
    NetworkPaper,
  },
  computed: mapState(['userinfo']),
  data() {
    return {
      fullscreenLoading: false,
      userAgent: '',
      loaded: false,
      status: {
        ipValue: '--',
        pingString: '--',
        downloadString: '--',
        uploadString: '--',
      },
      printData: {},
    };
  },
  created() {
    this.userAgent = window.navigator.userAgent;
  },
  mounted() {
    worker.addEventListener('message', this.updateStatus);
  },
  beforeDestroy() {
    worker.removeEventListener('message', this.updateStatus);
  },
  methods: {
    start() {
      this.fullscreenLoading = true;
      this.loaded = false;
      worker.postMessage({
        type: 'start',
        token: auth.getToken(),
      });
    },
    updateStatus(e) {
      if (e.data.type === 'process') {
        this.status = e.data;
      } else if (e.data.type === 'complete') {
        this.loaded = true;
        this.fullscreenLoading = false;

        aegis.reportTime({
          name: 'ping', // 自定义测速 name
          duration: e.data.pingValue,
        });
        aegis.reportTime({
          name: 'download',
          duration: e.data.downloadValue,
        });
        aegis.reportTime({
          name: 'upload',
          duration: e.data.uploadValue,
        });
        if (
          e.data.pingValue === -1 ||
          e.data.pingValue === '-1' ||
          e.data.pingValue > 200 ||
          e.data.downloadValue < 100 ||
          e.data.uploadValue < 100
        ) {
          aegis.error({
            msg: 'API连接慢',
            ext1: `用户: ${this.userinfo && this.userinfo.userName}`,
            ext2: `[IP: ${e.data.ipValue}] [Ping: ${e.data.pingString}] [Download: ${e.data.downloadString}] [Upload: ${e.data.uploadString}] [浏览器: ${navigator.userAgent}]`,
          });
        }
      }
    },
    exportReport() {
      this.fullscreenLoading = true;
      this.printData = {
        userinfo: this.userinfo,
        userAgent: this.userAgent,
        ...this.status,
      };
      this.$nextTick(() => {
        this.$refs.NetworkPaper.print();
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 1000);
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
